import { Alert } from '@interstate/components/Alert';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

import * as rollToSelectors from '@makemydeal/dr-dash-store/selectors/rollToSelectors';
import * as rollToOptionsActionTypes from '@makemydeal/dr-dash-store/actionTypes/rollToOptionsActionTypes';

import { ROLL_TO_OPTIONS_ADJUSTMENT_TYPE_LABEL } from '@makemydeal/dr-shared-types';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

export const RollToChangeAlert = () => {
    const targetStatus = useSelector(rollToSelectors.getTargetStatus);
    const dispatch = useDispatch();
    const [target, setTarget] = useState(targetStatus);

    useEffect(() => {
        setTarget(targetStatus);
        const handleClearRollToOptions = () => {
            dispatch({ type: rollToOptionsActionTypes.CLEAR_ROLL_TO_OPTIONS });
        };
        const timeoutId = setTimeout(handleClearRollToOptions, 5000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [targetStatus, dispatch]);

    return (
        <>
            {target && typeof target === 'object' && (
                <Alert type="success" sx={{ marginTop: '40px' }} data-testid="roll-success">
                    {`Roll-To ${
                        ROLL_TO_OPTIONS_ADJUSTMENT_TYPE_LABEL[target.name]
                    } on the Current working offer updated from ${formatDollarsAndCents(
                        target.previous
                    )} to ${formatDollarsAndCents(target.current)}`}
                </Alert>
            )}
        </>
    );
};

export default RollToChangeAlert;
